/* Sérenerve ™ — scripts du clone (PHARMAFR) */
(function () {
  'use strict';
  if (window.__srnLoaded) { return; }
  window.__srnLoaded = true;

  /* ---------- 1. Défilement vers le sélecteur de quantité ---------- */
  function buyTarget() {
    return document.querySelector('.quantity-breaks-container')
        || document.querySelector('.product-form')
        || document.querySelector('.product__info-wrapper')
        || document.querySelector('main-product, .main-product, #MainProduct');
  }
  function headerOffset() {
    var h = document.querySelector('.section-header, header.header, #shopify-section-header, sticky-header');
    var o = h ? h.getBoundingClientRect().height : 0;
    if (o > 90) { o = 90; }
    return o + 12;
  }
  function scrollToBuy() {
    var t = buyTarget();
    if (!t) { return; }
    var y = t.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
    var first = document.querySelector('.quantity-breaks-container .quantity-break');
    if (first) {
      first.classList.add('srn-flash');
      setTimeout(function () { first.classList.remove('srn-flash'); }, 1600);
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var btn = t.closest('[data-srn-scroll], .srn .adv-cta, .srn .adv-gf-cta, .srn .adv-sb-cta, .srn .adv-announce');
    if (!btn) { return; }
    e.preventDefault();
    e.stopPropagation();
    scrollToBuy();
  }, true);

  /* ---------- 2. Compte à rebours (fin de journée) ---------- */
  function timers() {
    var els = document.querySelectorAll('.srn .adv-sale-timer');
    if (!els.length) { return; }
    function tick() {
      var now = new Date();
      var mid = new Date(now); mid.setHours(24, 0, 0, 0);
      var d = Math.max(0, Math.floor((mid - now) / 1000));
      var h = Math.floor(d / 3600), m = Math.floor((d % 3600) / 60), s = d % 60;
      var txt = (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      for (var i = 0; i < els.length; i++) { els[i].textContent = txt; }
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- 3. Dates de livraison + compteur « en caisse » ---------- */
  var JOURS = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];
  var MOIS = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  function dates() {
    var d = new Date(); d.setDate(d.getDate() + 2);
    var label = JOURS[d.getDay()] + ' ' + d.getDate() + ' ' + MOIS[d.getMonth()];
    Array.prototype.forEach.call(document.querySelectorAll('.srn [data-srn-ship]'), function (el) {
      el.textContent = label;
    });
    var ord = document.querySelector('.srn [data-srn-order]');
    if (ord) {
      (function tick() {
        var now = new Date(), mid = new Date(now); mid.setHours(24, 0, 0, 0);
        var s = Math.max(0, Math.floor((mid - now) / 1000));
        var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
        ord.textContent = h + ' h ' + (m < 10 ? '0' : '') + m + ' min';
        setTimeout(tick, 1000);
      })();
    }
    var num = document.querySelector('.srn .adv-sb-num');
    if (num) {
      var c = 98 + Math.floor(Math.random() * 28);
      num.textContent = c;
      setInterval(function () {
        c += Math.floor(Math.random() * 5) - 2;
        if (c < 84) { c = 84; }
        if (c > 158) { c = 158; }
        num.textContent = c;
      }, 4000);
    }
    var yrs = document.querySelectorAll('.srn .adv-yr');
    for (var i = 0; i < yrs.length; i++) { yrs[i].textContent = new Date().getFullYear(); }
  }

  /* ---------- 4. Barre collante ---------- */
  function stickybar() {
    var bar = document.querySelector('.srn .adv-stickybar');
    if (!bar) { return; }
    function update() {
      var mobile = window.innerWidth <= 768;
      var info = buyTarget();
      var pastInfo = true;
      if (info) { pastInfo = info.getBoundingClientRect().bottom < 60; }
      var show = mobile ? true : pastInfo;
      if (show) { bar.classList.add('adv-sb-show'); } else { bar.classList.remove('adv-sb-show'); }
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- 5. Liste d'ingrédients (déroulant) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var b = t.closest('.adv-ing-toggle');
    if (!b) { return; }
    e.preventDefault();
    var list = b.nextElementSibling;
    if (list && list.classList.contains('adv-ing-list')) { list.classList.toggle('adv-ing-open'); }
  });

  /* ---------- 6. Carrousel d'avis ---------- */
  function carousel(track) {
    if (!track || track.getAttribute('data-srn-booted') === '1') { return; }
    var wrap = track.closest('.adv-cwrap');
    if (!wrap) { return; }
    var originals = Array.prototype.slice.call(track.querySelectorAll('.adv-cslide'));
    var n = originals.length;
    if (!n) { return; }
    track.setAttribute('data-srn-booted', '1');
    var root = track.closest('.srn') || document;
    var prev = wrap.querySelector('.adv-ca-prev');
    var next = wrap.querySelector('.adv-ca-next');
    var heading = root.querySelector('[data-srn-heading]');
    var dotsWrap = root.querySelector('.adv-cdots');
    var names = originals.map(function (s) { return s.getAttribute('data-heading') || ''; });
    var tpl = heading ? (heading.getAttribute('data-srn-heading') || '') : '';

    var fragPre = document.createDocumentFragment();
    var fragPost = document.createDocumentFragment();
    originals.forEach(function (s) { fragPre.appendChild(s.cloneNode(true)); });
    originals.forEach(function (s) { fragPost.appendChild(s.cloneNode(true)); });
    track.insertBefore(fragPre, track.firstChild);
    track.appendChild(fragPost);
    var all = Array.prototype.slice.call(track.querySelectorAll('.adv-cslide'));
    var index = n;
    var dots = [];

    function mark() {
      all.forEach(function (s, i) { s.classList.toggle('is-center', i === index); });
      var off = ((index % n) + n) % n;
      if (heading && tpl && names[off]) { heading.textContent = tpl.replace('%s', names[off]); }
      if (dots.length) { dots.forEach(function (b, i) { b.classList.toggle('is-active', i === off); }); }
    }
    function place(animate) {
      track.style.transition = animate ? '' : 'none';
      var el = all[index] || all[0];
      var x = wrap.offsetWidth / 2 - (el.offsetLeft + el.offsetWidth / 2);
      track.style.transform = 'translateX(' + x + 'px)';
      if (!animate) { track.getBoundingClientRect(); track.style.transition = ''; }
      mark();
    }
    function normalize() {
      if (index < n) { index += n; place(false); }
      else if (index >= 2 * n) { index -= n; place(false); }
    }
    track.addEventListener('transitionend', function (e) {
      if (e.target === track && e.propertyName === 'transform') { normalize(); }
    });
    function go(dir) { index += dir; place(true); }
    if (prev) { prev.addEventListener('click', function () { go(-1); }); }
    if (next) { next.addEventListener('click', function () { go(1); }); }

    var dragging = false, startX = 0, baseX = 0;
    function curX() { var m = /translateX\(([-0-9.]+)px\)/.exec(track.style.transform); return m ? parseFloat(m[1]) : 0; }
    function gapPx() { var cs = getComputedStyle(track); return parseFloat(cs.columnGap) || parseFloat(cs.gap) || 24; }
    track.addEventListener('pointerdown', function (e) {
      dragging = true; startX = e.clientX; baseX = curX();
      track.classList.add('dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });
    track.addEventListener('pointermove', function (e) {
      if (!dragging) { return; }
      track.style.transform = 'translateX(' + (baseX + (e.clientX - startX)) + 'px)';
    });
    function endDrag(e) {
      if (!dragging) { return; }
      dragging = false; track.classList.remove('dragging');
      var dx = (e.clientX || startX) - startX;
      var w = all[0].offsetWidth;
      var steps = Math.round(-dx / (w + gapPx()));
      if (steps === 0 && Math.abs(dx) > 50) { steps = dx < 0 ? 1 : -1; }
      index += steps;
      place(true);
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var di = 0; di < n; di++) {
        (function (d) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Aller à l’avis ' + (d + 1));
          b.addEventListener('click', function () { index = n + d; place(true); });
          dotsWrap.appendChild(b);
          dots.push(b);
        })(di);
      }
    }
    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { place(false); }, 120); });
    place(false);
    requestAnimationFrame(function () { place(false); });
    window.addEventListener('load', function () { place(false); });
    setTimeout(function () { place(false); }, 300);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { place(false); }).catch(function () {}); }
    Array.prototype.forEach.call(track.querySelectorAll('img'), function (img) {
      if (!img.complete) { img.addEventListener('load', function () { place(false); }, { once: true }); }
    });
  }

  /* ---------- 7. « Voir plus d'avis » ---------- */
  function moreReviews() {
    Array.prototype.forEach.call(document.querySelectorAll('.srn .adv-rl-more'), function (btn) {
      if (btn.getAttribute('data-srn-booted') === '1') { return; }
      btn.setAttribute('data-srn-booted', '1');
      var scope = btn.closest('.adv-rl') || document;
      function remaining() { return scope.querySelectorAll('.adv-rl-hidden:not(.adv-rl-show)'); }
      if (!remaining().length) { btn.style.display = 'none'; return; }
      btn.addEventListener('click', function () {
        var hidden = remaining();
        for (var i = 0; i < 5 && i < hidden.length; i++) { hidden[i].classList.add('adv-rl-show'); }
        if (!remaining().length) { btn.style.display = 'none'; }
      });
    });
  }

  var onceDone = false;
  function boot() {
    if (!onceDone) {
      onceDone = true;
      timers();
      dates();
      stickybar();
    }
    moreReviews();
    Array.prototype.forEach.call(document.querySelectorAll('.srn .adv-carousel2'), carousel);
  }
  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('load', boot);
})();
